import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { CRM_DASHBOARD_FEATURE_GROUP } from './group';

export const CRM_DASHBOARD_FEATURES = {
  READ: {
    guid: 'c7d2e5b8-1a43-4c69-8b27-6e9f1d2a0100',
    name: 'crm_dashboard:read',
    description: 'View the CRM dashboard',
    action: 'read',
    product: 'crm',
    parentGuid: CRM_DASHBOARD_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { CRM_DASHBOARD_FEATURE_GROUP } from './group';

export const CRM_DASHBOARD_MODULE: FeatureModule = {
  product: 'crm',
  groups: [CRM_DASHBOARD_FEATURE_GROUP],
  features: featureList(CRM_DASHBOARD_FEATURES),
};
